module.exports = __webpack_public_path__ + "static/img/poster2.ebf55d8e.png";